import React from "react";
import HeaderSection from "../../../Shop/components/HeaderSection/HeaderSection";
import useRelatedProducts from "../../../../hooks/useRelatedProducts";
import Loading from "../../../../components/Loading/Loading";
import localeText from "../../../../locale";
import ProductCardMobile from "../ProductCard/ProductCardMobile";
import Carousel from "../../../../components/Carousel/Carousel";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import ProductSectionsLoading from "../../../Shop/components/ProductSectionsLoading/ProductSectionsLoading";
import useLoadingSimulation from "../../../Shop/hooks/useLoadingSimulation";
import "./RelationedProducts.css";
import { Skeleton } from "primereact/skeleton";

const ProductTemplate = ({ product }) => {
  return (
    <div className="flex" style={{ flexBasis: "100%", flexGrow: 1, minHeight: "100%" }}>
      <ProductCardMobile product={product} />
    </div>
  );
};

const RelationedProducts = ({ productInfo }) => {
  const { showErrorToast } = useToastContext();
  const { loading, relatedProducts } = useRelatedProducts({
    productId: productInfo.data.product.id,
    onError: (code) => showErrorToast({ code }),
  });
  const isLoadingSimulation = useLoadingSimulation();

  if (loading)
    return (
      <>
        <hr style={{ borderTop: "solid 1px #B3BAC5" }}></hr>
        <div className="font-bold text-lg" style={{ color: "#344563" }}>
          {localeText("relatedProducts")}
        </div>
        <Carousel
          breakpoints={{
            350: { slidesPerView: 1.5, spaceBetween: 0 },
            520: { slidesPerView: 3, spaceBetween: 0 },
            768: { slidesPerView: 5, spaceBetween: 0 },
          }}
          items={[...Array(7)].map((_, i) => (
            <div key={i} className="flex flex-column gap-2">
              <Skeleton size="13rem" />
              <Skeleton width="100%" />
              <Skeleton width="100%" />
              <Skeleton width="100%" height="2rem" />
            </div>
          ))}
        />
      </>
    );
  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <>
      {/* <HeaderSection classNameTitle="pb-3" disableBoxModel>
        {localeText("relatedProducts")}
      </HeaderSection> */}
      <hr style={{ borderTop: "solid 1px #B3BAC5" }}></hr>
      <div className="font-bold text-lg" style={{ color: "#344563" }}>
        {localeText("relatedProducts")}
      </div>
      <Carousel
        breakpoints={{
          350: { slidesPerView: 1.5, spaceBetween: 0 },
          520: { slidesPerView: 3, spaceBetween: 0 },
          768: { slidesPerView: 5, spaceBetween: 0 },
        }}
        items={relatedProducts.map((product) => (
          <ProductTemplate product={product} />
        ))}
      />
    </>
  );
};

export default RelationedProducts;
